var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.href === 'false' ? 'div' : 'a',{tag:"component",staticClass:"v-button",class:{
    'v-button--light': _vm.light,
    'v-button--secondary': _vm.secondary,
    'v-button--result': _vm.isResult,
    'is-force-hover': _vm.forceHover,
  },attrs:{"href":_vm.href,"target":"_blank"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"v-button__label",class:['v-button__label--' + _vm.color]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }